<div class="info-strip-left">
  <button class="back-button" type="button" (click)="back('/property-search-result-pg')">
    <i class="fa fa-caret-left"></i> <p>Back</p>
  </button>
</div>
<div class="side-info" [ngStyle]="{'width':isImgVwVisible ? (screenWidth <= 768) ? '100%' : '600px' : '270px' , 'left': isImgVwVisible ? 'initial': (screenWidth <= 650) ? (collapsesideinfo)  ? '0px' : '-270px' :'initial' , 'z-index': isImgVwVisible ? 'initial' : (screenWidth <= 650) ? (collapsesideinfo) ? 888888888888 : 888888 : 'initial'}">
  <div class="navbg-image-page">
    <button (click)="toggleSideInfo()" class="nav-icon" type="button">
      <span [hidden]="collapsesideinfo==true" class="fa fa-bars fa-lg"></span>
      <span [hidden]="collapsesideinfo==false" class="fa fa-times fa-lg"></span>
    </button>
  </div>
  <!-- <property-search-doc-detail [recDocVM]="record" [isImgVwVisible]="isImgVwVisible" [loadingVisible]="isLoadingDetail" [book]="book" [page]="page" (moveToRef)="loadRef($event)" [ngStyle]=""></property-search-doc-detail>-->
  <div *ngIf="book; else showRegDoc">
    <app-rec-doc-detail-info [recDocVM]="record" [isImgVwVisible]="isImgVwVisible" [loadingVisible]="isLoadingDetail" [book]="book" [page]="page" (moveToRef)="loadRef($event)" [ngStyle]=""></app-rec-doc-detail-info>
  </div>
  <ng-template #showRegDoc>
    <app-reg-doc-detail [regDocVM]="record" [docNum]="docNum" [isImgVwVisible]="isImgVwVisible" [loadingVisible]="isLoadingDetail" (moveToRef)="loadRef($event)" [ngStyle]="" [linkname]="linkname"></app-reg-doc-detail>
  </ng-template>
</div>
<!--<property-search-doc-image [book]="book" [page]="page" [docId]="docId" (changeImgVwVisible)="getIsImgVwVisible($event)" (changeInInfo)="loadInfo($event)"></property-search-doc-image>-->
<div *ngIf="book; else showRegImg">
  <app-rec-doc-detail-parent [book]="book" [page]="page" [docId]="docId" (changeImgVwVisible)="getIsImgVwVisible($event)" (changeInInfo)="loadInfo($event)"></app-rec-doc-detail-parent>
</div>
<ng-template #showRegImg>
  <app-reg-doc-image [docId]="docId" [docNum]="docNum" (changeImgVwVisible)="getIsImgVwVisible($event)" (changeInInfo)="loadInfo($event)"></app-reg-doc-image>
</ng-template>
